import React, { useState, useEffect, useRef, useContext, Fragment } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import { MenuItem } from "@material-ui/core";

import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { i18n } from "../../translate/i18n";
import Switch from "@material-ui/core/Switch";
import { isArray } from "lodash";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import ColorPicker from "../ColorPicker";
import DeleteOutline from "@material-ui/icons/DeleteOutline";


import SchedulesForm from "../SchedulesForm";
import AerosDialog from "../AerosDialog";
import AerosConfirmModal from "../AerosConfirmModal";
import useQueueModalStyles from "./queueModalStyles";
import { AEROS, stateText } from "../../styles/aerosTokens";
import { useTheme, alpha } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import TuneIcon from "@material-ui/icons/Tune";
import ScheduleIcon from "@material-ui/icons/Schedule";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import PersonIcon from "@material-ui/icons/Person";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import HubIcon from "@material-ui/icons/DeviceHub";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { AuthContext } from "../../context/Auth/AuthContext";
import useQueues from "../../hooks/useQueues";
import usePlans from "../../hooks/usePlans";
// import { ColorBox } from "material-ui-color";



const QueueSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  color: Yup.string().min(3, "Too Short!").max(9, "Too Long!").required(),
  greetingMessage: Yup.string(),
  chatbots: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().min(4, "too short").required("Required"),
      })
    )
    .required("Must have friends"),
});

// Operações SGP realmente tratadas pelo backend (sgpListenerOficial).
// Manter em sincronia com backend/src/helpers/IsSgpIntegration.ts.
const TIPOS_INTEGRACAO_SGP = [
  { valor: "SB", rotulo: "2ª Via Boleto" },
  { valor: "LC", rotulo: "Liberação por Confiança" }
];

const QueueModal = ({ open, onClose, queueId, onEdit, onSaved, userCount = 0 }) => {
  const m = useQueueModalStyles();
  const theme = useTheme();

  const initialState = {
    name: "",
    color: "",
    greetingMessage: "",
    chatbots: [],
    outOfHoursMessage: "",
    orderQueue: "",
    tipoIntegracao: "NA",
    tempoRoteador: 0,
    ativarRoteador: false,
    integrationId: "",
    fileListId: "",
    closeTicket: false,
    typeRandomMode: "RANDOM",
    randomizeImmediate: false
  };

  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);
  const [queue, setQueue] = useState(initialState);
  // O rodapé fica FORA do <Form> (é a casca do AerosDialog), então o submit
  // vai pelo ref em vez de um botão type="submit".
  const formikRef = useRef(null);
  const [activeStep, setActiveStep] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isGreetingMessageEdit, setGreetingMessageEdit] = useState(null);

  const [integrations, setIntegrations] = useState([]);

  // Só integração SGP usa tipoIntegracao. Gravar esse campo para n8n/typebot/
  // webhook poluía o jsonContent da integração e fazia o roteamento do backend
  // tratar n8n como SGP, engolindo o disparo do webhook.
  // Alias curto usado no render.
  const isSgpSelected = (integrationId) => isSgpIntegration(integrationId);

  const isSgpIntegration = (integrationId) =>
    integrations.some(
      (integration) =>
        String(integration.id) === String(integrationId) &&
        integration.type === "SGP"
    );
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [tab, setTab] = useState(0);
  const [file, setFile] = useState(null);
  const { user, socket } = useContext(AuthContext);
  const [searchParam, setSearchParam] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedQueueOption, setSelectedQueueOption] = useState("");
  const { findAll: findAllQueues } = useQueues();
  const [allQueues, setAllQueues] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const isMounted = useRef(true);

  const initialStateSchedule = [
    { weekday: i18n.t("queueModal.serviceHours.monday"), weekdayEn: "monday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.tuesday"), weekdayEn: "tuesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.wednesday"), weekdayEn: "wednesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.thursday"), weekdayEn: "thursday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.friday"), weekdayEn: "friday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: "Sábado", weekdayEn: "saturday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: "Domingo", weekdayEn: "sunday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" }
  ];


  const [schedules, setSchedules] = useState(initialStateSchedule);

  const companyId = user.companyId;

  const { get: getSetting } = useCompanySettings();
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      const setting = await getSetting({
        "column": "scheduleType"
      });
      if (setting.scheduleType === "queue") setSchedulesEnabled(true);
    }
    fetchData();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/files/", {
          params: { companyId }
        });

        setFile(data.files);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!queueId) return;
      try {
        const { data } = await api.get(`/queue/${queueId}`);

        setQueue((prevState) => {
          return {
            ...prevState,
            ...data,
            // filas criadas antes da coluna vêm com null; o Select é controlado
            tipoIntegracao: data.tipoIntegracao || "NA"
          };
        });

        if (isArray(data.schedules) && data.schedules.length > 0)
          setSchedules(data.schedules);
      } catch (err) {
        toastError(err);
      }
    })();

    return () => {
      setQueue({
        name: "",
        color: "",
        greetingMessage: "",
        chatbots: [],
        outOfHoursMessage: "",
        orderQueue: "",
        tipoIntegracao: "NA",
        tempoRoteador: "",
        ativarRoteador: false,
        integrationId: "",
        fileListId: "",
        closeTicket: false,
        typeRandomMode: "RANDOM",
        randomizeImmediate: false
      });
    };
  }, [queueId, open]);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);

      };
      loadQueues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchParam.length < 3) {
      setLoading(false);
      setSelectedQueueOption("");
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      //setLoading(true);
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/users/");
          setUserOptions(data.users);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queueIntegration");

        setIntegrations(data.queueIntegrations);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {

    if (activeStep !== null) {
      setSelectedQueueOption(queue.chatbots?.[activeStep]?.optQueueId);
    }
  }, [activeStep, queue.chatbots]);

  const handleClose = () => {
    onClose();
    setActiveStep(null);
    setGreetingMessageEdit(null);
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Clique em salvar para registar as alterações");
    setSchedules(values);
    setTab(0);
  };

  const handleCloseConfirmationModal = () => {
    setConfirmModalOpen(false);
    setSelectedQueue(null);
  };

  const handleDeleteQueue = async (optionsId) => {
    try {
      await api.delete(`/chatbot/${optionsId}`);
      const { data } = await api.get(`/queue/${queueId}`);
      setQueue(initialState);
      setQueue(data);

      setGreetingMessageEdit(null);
      toast.success(`${i18n.t("queues.toasts.deleted")}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleSaveQueue = async (values) => {
    try {
      // tipoIntegracao é salvo na PRÓPRIA FILA (coluna Queues.tipoIntegracao).
      // Antes era espelhado no jsonContent da QueueIntegration, que é
      // compartilhada entre filas — duas filas SGP sobrescreviam o tipo uma da
      // outra, e o "NA" default vazava para integrações n8n/webhook.
      const payload = {
        ...values,
        // fora do SGP o campo não se aplica; não guardar o "NA" residual
        tipoIntegracao: isSgpIntegration(values.integrationId)
          ? values.tipoIntegracao
          : "",
        schedules
      };

      if (queueId) {
        await api.put(`/queue/${queueId}`, payload);
      } else {
        await api.post("/queue", payload);
      }

      toast.success(i18n.t("aeros.queues.modal.saved"));
      // A listagem precisa recarregar: as contagens (atendentes, abertos,
      // opções do bot) só vêm de GET /queue, não do evento de socket.
      if (typeof onSaved === "function") onSaved();
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleSaveBot = async (values) => {
    console.log(values)
    try {
      if (queueId) {
        const { data } = await api.put(`/queue/${queueId}`, values);
        if (data.chatbots && data.chatbots.length) {
          onEdit(data);
          setQueue(data);
        }
      } else {
        const { data } = await api.post("/queue", values);
        if (data.chatbots && data.chatbots.length) {
          setQueue(data);
          onEdit(data);
          handleClose();
        }
      }

      setGreetingMessageEdit(null)
      toast.success(`${i18n.t("queues.toasts.success")}`);

    } catch (err) {
      toastError(err);
    }
  };

  // const renderColorBox = (open, handleClose, color, handleColorChange) => {
  //   return (
  //     <Dialog open={open} onClose={handleClose}>

  //       <DialogTitle>Escolha uma cor</DialogTitle>
  //       <DialogContent>
  //         <ColorBox
  //           disableAlpha={true}
  //           hslGradient={false}
  //           style={{ margin: '20px auto 0' }}
  //           value={color}
  //           onChange={handleColorChange} />
  //       </DialogContent>
  //       <DialogActions>
  //         <Button onClick={handleClose} color="primary">
  //           Cancelar
  //         </Button>
  //         <Button
  //           color="primary"
  //           variant="contained"
  //           className={classes.btnWrapper}
  //           onClick={handleClose} >
  //           OK
  //         </Button>
  //       </DialogActions>
  //     </Dialog>
  //   )
  // }
  // Tipos do menu do bot. O VALOR é o que fica gravado em `Chatbot.queueType`
  // e é lido pelo wbotMessageListener — "attendent" está escrito assim no
  // banco desde sempre; corrigir a grafia aqui quebraria os bots existentes.
  const BOT_TYPES = [
    { value: "text", icon: ChatBubbleOutlineIcon, color: "#9CA3B8", key: "text" },
    { value: "attendent", icon: PersonIcon, color: AEROS.cyan, key: "user" },
    { value: "queue", icon: AccountTreeIcon, color: "#C08BFF", key: "queue" },
    { value: "integration", icon: HubIcon, color: AEROS.success, key: "integration" },
    { value: "file", icon: AttachFileIcon, color: AEROS.warning, key: "file" },
  ];

  const botTypeMeta = (valor) =>
    BOT_TYPES.find((t) => t.value === valor) || BOT_TYPES[0];

  const renderLabel = (texto, obrigatorio) => (
    <div className={m.label}>
      {texto}
      {obrigatorio && <span className={m.required}>*</span>}
    </div>
  );

  const campo = (nome, rotulo, extra = {}) => (
    <div>
      {renderLabel(rotulo, extra.required)}
      <Field
        as={TextField}
        name={nome}
        type={extra.type || "text"}
        variant="outlined"
        fullWidth
        multiline={!!extra.multiline}
        minRows={extra.multiline || undefined}
        disabled={extra.disabled}
        className={m.input}
        inputProps={{ "aria-label": rotulo }}
      />
      {extra.hint && <div className={m.hint}>{extra.hint}</div>}
    </div>
  );

  // ---------- aba 1: Dados da fila ----------
  const renderDados = (values, setFieldValue) => (
    <div className={m.body}>
      <div className={m.row3}>
        {campo("name", i18n.t("aeros.queues.form.name"), { required: true })}
        <div>
          {renderLabel(i18n.t("aeros.queues.form.color"), true)}
          <div className={m.colorRow}>
            <button
              type="button"
              className={m.swatchButton}
              style={{ backgroundColor: values.color || "#7c7c7c" }}
              onClick={() => setColorPickerModalOpen(true)}
              aria-label={i18n.t("aeros.queues.form.color")}
            />
            <Field
              as={TextField}
              name="color"
              variant="outlined"
              fullWidth
              className={m.input}
              inputProps={{ "aria-label": i18n.t("aeros.queues.form.color") }}
            />
          </div>
        </div>
        {campo("orderQueue", i18n.t("aeros.queues.form.order"), { type: "number" })}
      </div>

      <div className={m.optionRow}>
        <SmartToyIcon />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className={m.optionTitle}>
            {i18n.t("aeros.queues.form.closeTicket")}
          </div>
          <div className={m.optionDesc}>
            {i18n.t("aeros.queues.form.closeTicketHint")}
          </div>
        </div>
        <Switch
          classes={{ root: m.switchRoot }}
          checked={!!values.closeTicket}
          onChange={(e) => setFieldValue("closeTicket", e.target.checked)}
          inputProps={{ "aria-label": i18n.t("aeros.queues.form.closeTicket") }}
        />
      </div>

      <div className={m.optionRow}>
        <SyncAltIcon />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className={m.optionTitle}>{i18n.t("aeros.queues.form.rotate")}</div>
          <div className={m.optionDesc}>{i18n.t("aeros.queues.form.rotateHint")}</div>
        </div>
        <Switch
          classes={{ root: m.switchRoot }}
          checked={!!values.ativarRoteador}
          onChange={(e) => setFieldValue("ativarRoteador", e.target.checked)}
          inputProps={{ "aria-label": i18n.t("aeros.queues.form.rotate") }}
        />
      </div>

      {values.ativarRoteador && (
        <div className={m.pair}>
          {campo("tempoRoteador", i18n.t("aeros.queues.form.rotateTime"), {
            type: "number",
            hint: i18n.t("aeros.queues.form.minutes"),
          })}
          <div>
            {renderLabel(i18n.t("aeros.queues.form.rotateType"))}
            <Field
              as={TextField}
              select
              name="typeRandomMode"
              variant="outlined"
              fullWidth
              className={m.input}
            >
              <MenuItem value="random">{i18n.t("aeros.queues.form.random")}</MenuItem>
              <MenuItem value="ordered">{i18n.t("aeros.queues.form.ordered")}</MenuItem>
            </Field>
          </div>
        </div>
      )}

      <div className={m.row3}>
        <div>
          {renderLabel(i18n.t("aeros.queues.form.integration"))}
          <Field
            as={TextField}
            select
            name="integrationId"
            variant="outlined"
            fullWidth
            className={m.input}
            SelectProps={{ displayEmpty: true }}
          >
            <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
            {integrations.map((integration) => (
              <MenuItem key={integration.id} value={integration.id}>
                {integration.name}
              </MenuItem>
            ))}
          </Field>
        </div>
        <div>
          {renderLabel(i18n.t("aeros.queues.form.integrationType"))}
          <Field
            as={TextField}
            select
            name="tipoIntegracao"
            variant="outlined"
            fullWidth
            disabled={!isSgpSelected(values.integrationId)}
            className={m.input}
            SelectProps={{ displayEmpty: true }}
          >
            <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
            {TIPOS_INTEGRACAO_SGP.map((tipo) => (
              <MenuItem key={tipo.valor} value={tipo.valor}>
                {tipo.rotulo}
              </MenuItem>
            ))}
          </Field>
        </div>
        <div>
          {renderLabel(i18n.t("aeros.queues.form.fileList"))}
          <Field
            as={TextField}
            select
            name="fileListId"
            variant="outlined"
            fullWidth
            className={m.input}
            SelectProps={{ displayEmpty: true }}
          >
            <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
            {(file || []).map((f) => (
              <MenuItem key={f.id} value={f.id}>
                {f.name}
              </MenuItem>
            ))}
          </Field>
        </div>
      </div>

      {campo("greetingMessage", i18n.t("aeros.queues.form.greeting"), {
        multiline: 3,
      })}
      {campo("outOfHoursMessage", i18n.t("aeros.queues.form.outOfHours"), {
        multiline: 2,
        required: true,
      })}
    </div>
  );

  // ---------- aba 2: Chatbot ----------
  const renderChatbot = (values, setFieldValue) => {
    const opcoes = values.chatbots || [];
    const atual = activeStep !== null ? opcoes[activeStep] : null;
    const meta = atual ? botTypeMeta(atual.queueType) : null;
    const TipoIcon = meta?.icon;

    const prefixo = `chatbots[${activeStep}]`;

    return (
      <div className={m.botSplit}>
        <div className={m.botList}>
          <div className={m.eyebrow}>{i18n.t("aeros.queues.bot.list")}</div>

          {opcoes.length === 0 && (
            <div className={m.optionDesc}>{i18n.t("aeros.queues.bot.empty")}</div>
          )}

          {opcoes.map((opcao, index) => {
            const tipo = botTypeMeta(opcao.queueType);
            const Icon = tipo.icon;
            const ativo = activeStep === index;
            return (
              <button
                type="button"
                key={opcao.id || `nova-${index}`}
                className={`${m.optionCard} ${ativo ? m.optionCardActive : ""}`}
                onClick={() => setActiveStep(index)}
              >
                <span
                  className={`${m.optionNumber} ${
                    ativo ? m.optionNumberActive : ""
                  }`}
                >
                  {index + 1}
                </span>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span className={m.optionName} style={{ display: "block" }}>
                    {opcao.name || i18n.t("aeros.queues.bot.creating")}
                  </span>
                  <span className={m.optionMeta} style={{ display: "block" }}>
                    {opcao.greetingMessage}
                  </span>
                  <span
                    className={m.typePill}
                    style={{
                      color: stateText(theme, tipo.color, ""),
                      backgroundColor: alpha(tipo.color, 0.14),
                    }}
                  >
                    <Icon />
                    {i18n.t(`aeros.queues.bot.types.${tipo.key}`)}
                  </span>
                </span>
              </button>
            );
          })}

          <Button
            className={m.addOption}
            startIcon={<AddIcon />}
            onClick={() => {
              const novas = [
                ...opcoes,
                {
                  name: "",
                  greetingMessage: "",
                  queueType: "text",
                  closeTicket: false,
                },
              ];
              setFieldValue("chatbots", novas);
              setActiveStep(novas.length - 1);
            }}
          >
            {i18n.t("aeros.queues.bot.addOption")}
          </Button>
        </div>

        <div className={m.botEditor}>
          {!atual ? (
            <div className={m.editorEmpty}>
              {i18n.t("aeros.queues.bot.emptyEditor")}
            </div>
          ) : (
            <>
              <div className={m.eyebrow}>
                {i18n.t("aeros.queues.bot.editing", { n: activeStep + 1 })}
              </div>

              {campo(`${prefixo}.name`, i18n.t("aeros.queues.bot.optionTitle"), {
                required: true,
              })}

              <div>
                {renderLabel(i18n.t("aeros.queues.bot.type"))}
                <div className={m.typeGrid} role="radiogroup">
                  {BOT_TYPES.map((tipo) => {
                    const Icon = tipo.icon;
                    const ativo = atual.queueType === tipo.value;
                    return (
                      <button
                        key={tipo.value}
                        type="button"
                        role="radio"
                        aria-checked={ativo}
                        className={m.typeCard}
                        style={
                          ativo
                            ? {
                                borderColor: alpha(tipo.color, 0.6),
                                backgroundColor: alpha(tipo.color, 0.1),
                                color: theme.palette.text.primary,
                              }
                            : undefined
                        }
                        onClick={() =>
                          setFieldValue(`${prefixo}.queueType`, tipo.value)
                        }
                      >
                        <Icon
                          style={{
                            color: ativo
                              ? stateText(theme, tipo.color, "")
                              : theme.palette.aeros.textTertiary,
                          }}
                        />
                        {i18n.t(`aeros.queues.bot.types.${tipo.key}`)}
                      </button>
                    );
                  })}
                </div>
              </div>

              {atual.queueType === "attendent" && (
                <div>
                  {renderLabel(i18n.t("aeros.queues.bot.targetUser"), true)}
                  <Field
                    as={TextField}
                    select
                    name={`${prefixo}.optUserId`}
                    variant="outlined"
                    fullWidth
                    className={m.input}
                    SelectProps={{ displayEmpty: true }}
                  >
                    <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
                    {userOptions.map((u) => (
                      <MenuItem key={u.id} value={u.id}>
                        {u.name}
                      </MenuItem>
                    ))}
                  </Field>
                </div>
              )}

              {atual.queueType === "queue" && (
                <div>
                  {renderLabel(i18n.t("aeros.queues.bot.targetQueue"), true)}
                  <Field
                    as={TextField}
                    select
                    name={`${prefixo}.optQueueId`}
                    variant="outlined"
                    fullWidth
                    className={m.input}
                    SelectProps={{ displayEmpty: true }}
                  >
                    <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
                    {allQueues.map((q) => (
                      <MenuItem key={q.id} value={q.id}>
                        {q.id === queueId
                          ? i18n.t("aeros.queues.bot.currentQueue", { name: q.name })
                          : q.name}
                      </MenuItem>
                    ))}
                  </Field>
                </div>
              )}

              {atual.queueType === "integration" && (
                <div>
                  {renderLabel(i18n.t("aeros.queues.bot.targetIntegration"), true)}
                  <Field
                    as={TextField}
                    select
                    name={`${prefixo}.optIntegrationId`}
                    variant="outlined"
                    fullWidth
                    className={m.input}
                    SelectProps={{ displayEmpty: true }}
                  >
                    <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
                    {integrations.map((i) => (
                      <MenuItem key={i.id} value={i.id}>
                        {i.name}
                      </MenuItem>
                    ))}
                  </Field>
                </div>
              )}

              {atual.queueType === "file" && (
                <div>
                  {renderLabel(i18n.t("aeros.queues.bot.targetFile"), true)}
                  <Field
                    as={TextField}
                    select
                    name={`${prefixo}.optFileId`}
                    variant="outlined"
                    fullWidth
                    className={m.input}
                    SelectProps={{ displayEmpty: true }}
                  >
                    <MenuItem value="">{i18n.t("aeros.queues.form.none")}</MenuItem>
                    {(file || []).map((f) => (
                      <MenuItem key={f.id} value={f.id}>
                        {f.name}
                      </MenuItem>
                    ))}
                  </Field>
                </div>
              )}

              {campo(
                `${prefixo}.greetingMessage`,
                i18n.t("aeros.queues.bot.message"),
                { multiline: 3, required: true }
              )}

              <div className={m.optionRow}>
                <SmartToyIcon />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className={m.optionTitle}>
                    {i18n.t("aeros.queues.bot.closeAfter")}
                  </div>
                </div>
                <Switch
                  classes={{ root: m.switchRoot }}
                  checked={!!atual.closeTicket}
                  onChange={(e) =>
                    setFieldValue(`${prefixo}.closeTicket`, e.target.checked)
                  }
                  inputProps={{ "aria-label": i18n.t("aeros.queues.bot.closeAfter") }}
                />
              </div>

              <div className={m.editorActions}>
                <Button
                  className={m.ghostButton}
                  startIcon={<DeleteOutline />}
                  onClick={() => {
                    // Opção ainda não salva sai só do formulário; a que já tem
                    // id passa pela confirmação, porque some do bot em produção.
                    if (!atual.id) {
                      const novas = opcoes.filter((_, i) => i !== activeStep);
                      setFieldValue("chatbots", novas);
                      setActiveStep(novas.length ? 0 : null);
                      return;
                    }
                    setSelectedQueue(atual);
                    setConfirmModalOpen(true);
                  }}
                >
                  {i18n.t("aeros.queues.bot.deleteOption")}
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const TABS = [
    { icon: TuneIcon, label: i18n.t("aeros.queues.tabs.data") },
    { icon: SmartToyIcon, label: i18n.t("aeros.queues.tabs.bot") },
    ...(schedulesEnabled
      ? [{ icon: ScheduleIcon, label: i18n.t("aeros.queues.tabs.schedules") }]
      : []),
  ];

  const footer = (
    <div className={m.footer}>
      <div className={m.footerActions}>
        <Button className={m.cancelButton} onClick={handleClose}>
          {i18n.t("aeros.flow.cancel")}
        </Button>
        <Button
          className={m.saveButton}
          onClick={() => formikRef.current?.submitForm()}
        >
          {i18n.t("aeros.queues.modal.save")}
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <AerosConfirmModal
        open={confirmModalOpen}
        onClose={handleCloseConfirmationModal}
        onConfirm={() => handleDeleteQueue(selectedQueue?.id)}
        icon={<DeleteForeverIcon />}
        title={i18n.t("aeros.queues.bot.deleteTitle", {
          name: selectedQueue?.name || "",
        })}
        description={i18n.t("aeros.queues.bot.deleteBody")}
        confirmLabel={i18n.t("aeros.queues.bot.deleteOption")}
      />

      <AerosDialog
        open={open}
        onClose={handleClose}
        width={900}
        title={
          queueId
            ? i18n.t("aeros.queues.modal.edit", { name: queue.name || "" })
            : i18n.t("aeros.queues.modal.add")
        }
        subtitle={
          queueId
            ? i18n.t("aeros.queues.modal.subtitle", {
                id: queueId,
                count: userCount,
              })
            : i18n.t("aeros.queues.modal.subtitleNew")
        }
        footer={tab === 2 ? null : footer}
        flushBody
      >
        <div className={m.tabsRow} role="tablist">
          {TABS.map((item, idx) => {
            const Icon = item.icon;
            return (
              <button
                key={item.label}
                type="button"
                role="tab"
                aria-selected={tab === idx}
                className={`${m.tab} ${tab === idx ? m.tabActive : ""}`}
                onClick={() => setTab(idx)}
              >
                <Icon />
                {item.label}
              </button>
            );
          })}
        </div>

        {tab === 2 ? (
          <div className={m.schedulesArea}>
            <SchedulesForm
              loading={false}
              onSubmit={handleSaveSchedules}
              initialValues={schedules}
              labelSaveButton={i18n.t("aeros.queues.modal.save")}
            />
            <div className={m.schedulesHint}>
              <InfoOutlinedIcon />
              {i18n.t("aeros.queues.schedules.hint")}
            </div>
          </div>
        ) : (
          <Formik
            innerRef={formikRef}
            initialValues={queue}
            validateOnChange={false}
            enableReinitialize={true}
            validationSchema={QueueSchema}
            onSubmit={(values, actions) => {
              handleSaveQueue(values);
              actions.setSubmitting(false);
            }}
          >
            {({ values, setFieldValue }) => (
              <Form>
                {tab === 0 && renderDados(values, setFieldValue)}
                {tab === 1 && renderChatbot(values, setFieldValue)}
              </Form>
            )}
          </Formik>
        )}
      </AerosDialog>

      {colorPickerModalOpen && (
        <ColorPicker
          open={colorPickerModalOpen}
          handleClose={() => setColorPickerModalOpen(false)}
          onChange={(color) => {
            formikRef.current?.setFieldValue("color", color);
            setColorPickerModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default QueueModal;
